
import React, { useState } from 'react';
import { utc_local, get_order_status_color, payment_status_color } from '../../helpers/Helper';
import { post } from '../../helpers/api_helper';
import { POST_GET_ORDER_DETAIL, POST_UPDATE_ORDER_STATUS, PRINT_ADDRESS, PRINT_INVOICE } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import useMounted from '../../hooks/useMounted';
import Loader from '../../components/Loader';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { amountFormat } from './../../helpers/Helper';
import $ from 'jquery';
import StarRating from '../../components/StarRating';


const OrdersDetail = (props) => {
    const navigate = useNavigate();

    const [isLoader, setLoader] = useState(0);
    const { id } = useParams()
    const [OrderDetail, SetOrderDetail] = useState({});
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [OrderFormInputs, setOrderFormInputs] = useState({ orderId: 0, orderStatus: '', orderNotes: '', noteType: 'internal' });


    useMounted(() => {
        async function get_detaile() {
            await getOrderDetail();
            setLoader(1);
        }
        get_detaile();
    }, [])


    const getOrderDetail = async () => {
        SetOrderDetail({})
        var res_data = await post(POST_GET_ORDER_DETAIL, { orderId: id });
        if (res_data.status) {
            res_data.data.orderDetail.orderStatusLog = (res_data.data.orderDetail.orderStatusLog)? res_data.data.orderDetail.orderStatusLog.reverse() : [];
            SetOrderDetail(res_data.data.orderDetail);
            OrderFormInputs.orderId = id;
            OrderFormInputs.orderStatus = res_data.data.orderDetail.orderStatus;
            setOrderFormInputs({ ...OrderFormInputs })
        } else {
            toast.error(res_data.message);
            navigate("/orders");
        }
    }


    const handleSubmitOrderStatus = async (event) => {
        event.preventDefault();
        SetButtonDisabled(true);
        var res_data = await post(POST_UPDATE_ORDER_STATUS, OrderFormInputs);
        if (res_data.status) {
            toast(res_data.message);
            OrderFormInputs.orderNotes = '';
            setOrderFormInputs({ ...OrderFormInputs });
            await getOrderDetail();

            $('.modal-close').click();
        } else {
            toast.error(res_data.message);
        }
        SetButtonDisabled(false);
    }

    // input text change handler
    const handleInputChangeOrderStatus = (event) => {
        OrderFormInputs[event.target.name] = event.target.value;
        setOrderFormInputs({ ...OrderFormInputs });
    }


    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='m-0'>Order Detailes</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                    <Link to={PRINT_INVOICE + OrderDetail.orderId} target="_blank" className='btn btn-primary btn-sm'>Print Invoice</Link> &nbsp; &nbsp;
                                    <Link to={PRINT_ADDRESS + OrderDetail.orderId} target="_blank" className='btn btn-primary btn-sm'>Print Shipping Address</Link>
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <div className='col-sm-4'>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className='col-sm-12'>
                                                <h6>Order Info</h6>
                                            </div>
                                            <table className='table'>
                                                <tr>
                                                    <td>Order No :</td>
                                                    <td>#{OrderDetail.orderId}</td>
                                                </tr>
                                                <tr>
                                                    <td>Order Date :</td>
                                                    <td>{utc_local(OrderDetail.createdAt, 'DD MMM YYYY')}</td>
                                                </tr>
                                                <tr>
                                                    <td>Order Status :</td>
                                                    <td>
                                                        <span className={`badge text-white p-2 text-capitalize ${get_order_status_color(OrderDetail.orderStatus)}`}>{OrderDetail.orderStatus}</span>
                                                        &nbsp; &nbsp; &nbsp;<button className="btn btn-sm text-primary p-0" data-bs-toggle="modal" data-bs-target="#EditModal" ><i className="bx bx-edit"></i></button>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-sm-4'>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className='col-sm-12'>
                                                <h6>Billing Info</h6>
                                            </div>
                                            <table className='table'>
                                                <tr width={'80px'}>
                                                    <td>Name :</td>
                                                    <td>{OrderDetail.name}</td>
                                                </tr>
                                                <tr>
                                                    <td>Email :</td>
                                                    <td>{OrderDetail.email}</td>
                                                </tr>
                                                <tr>
                                                    <td>Phone :</td>
                                                    <td>{OrderDetail.phoneNo}</td>
                                                </tr>
                                                <tr>
                                                    <td >Address :</td>
                                                    <td >{OrderDetail.address}, {OrderDetail.city}, {OrderDetail.countryName} - {OrderDetail.zipCode}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-sm-4'>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className='col-sm-12'>
                                                <h6>Shipping Info</h6>
                                            </div>
                                            <table className='table'>
                                                <tr>
                                                    <td width={'80px'}>Name :</td>
                                                    <td>{OrderDetail?.shippingAddress?.name}</td>
                                                </tr>
                                                <tr>
                                                    <td>Phone :</td>
                                                    <td>{OrderDetail?.shippingAddress?.phoneNo}</td>
                                                </tr>
                                                <tr>
                                                    <td >Address :</td>
                                                    <td >{OrderDetail?.shippingAddress?.address}, {OrderDetail?.shippingAddress?.city}, {OrderDetail?.shippingAddress?.countryName} - {OrderDetail?.shippingAddress?.zipCode}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-4'>
                                <div className='col-sm-4'>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className='col-sm-12'>
                                                <h6>Payment Info</h6>
                                            </div>
                                            <table className='table'>
                                                <tr>
                                                    <td width={'100px'}>Method :</td>
                                                    <td>{OrderDetail.paymentMethod}</td>
                                                </tr>
                                                <tr>
                                                    <td>Trx Id :</td>
                                                    <td>{OrderDetail.paymenTransactionId}</td>
                                                </tr>
                                                <tr>
                                                    <td>Status :</td>
                                                    <td>
                                                        <span className={`badge text-white p-2 text-capitalize ${payment_status_color(OrderDetail.paymentStatus)}`}>{OrderDetail.paymentStatus}</span>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <div className='col-sm-12'>
                                    <div className='table-responsive'>
                                        <table className='table table-border table-sm'>
                                            <thead>
                                                <tr>
                                                    <th width="50">Image.</th>
                                                    <th>Product Detailes</th>
                                                    <th width="150px" className='text-center'>Qty</th>
                                                    <th width="150px" >Price</th>
                                                    <th width="150px" className='text-right'>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {OrderDetail.productInfo && OrderDetail.productInfo.map((productDetail, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <img src={productDetail.productInfo.Image1} style={{ "maxWidth": "140px", "maxHeight": "140px" }} alt='Product' />
                                                        </td>
                                                        <td>
                                                            <p className='m-0'><b style={{ "color": "#60007F" }}><small> {productDetail.productInfo.designName}</small></b></p>
                                                            <p className='m-0'><small>Stone : {productDetail.productInfo.stoneName}</small></p>
                                                            <p className='m-0'><small>Size : {productDetail.productInfo.sizeName}</small></p>
                                                            <p className='m-0'><small>Metal : {productDetail.productInfo.karateName} - {productDetail.productInfo.shadeCode}</small></p>
                                                            {/* <p className='m-0'><small>Quantity : {productDetail.qty}</small></p> */}
                                                            <p className='m-0'><small>Weight : {productDetail.productInfo.grossWeight}gm</small></p>
                                                        </td>
                                                        <td className='text-center'>
                                                            {productDetail.qty}
                                                        </td>
                                                        <td>
                                                            {amountFormat(productDetail.price)}
                                                        </td>
                                                        <td className='text-right'>
                                                            {amountFormat(productDetail.totalAmount)}
                                                        </td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td rowSpan={3} colSpan={3} className='pt-3 pb-3'>
                                                        <p className='mb-2'>Order Note : </p>
                                                        <p className='mb-2'>{OrderDetail.orderNote}</p>
                                                    </td>
                                                    <td className='pt-3 pb-3'>Subtotal</td>
                                                    <td className='text-right pt-3 pb-3'>{amountFormat(OrderDetail.totalPrice)}</td>
                                                </tr>
                                                <tr>
                                                    <td className='pt-3 pb-3'>VAT ({OrderDetail.vatPercentage}%)</td>
                                                    <td className='text-right pt-3 pb-3'>{amountFormat(OrderDetail.totalVat)}</td>
                                                </tr>
                                                <tr>
                                                    <td className='pt-3 pb-3'><h5 className='mb-0' style={{ "color": "#60007F" }}>Grand Total </h5></td>
                                                    <td className='text-right pt-3 pb-3'><h5 className='mb-0' style={{ "color": "#60007F" }}>{amountFormat(OrderDetail.grandTotal)}</h5></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className='row'>
                <div className='col-sm-12'>
                    <div class="nav-align-top mb-4">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                                <button
                                    type="button"
                                    class="nav-link active"
                                    role="tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#navs-top-home"
                                    aria-controls="navs-top-home"
                                    aria-selected="true">
                                    User Activity Log
                                </button>
                            </li>
                            <li class="nav-item">
                                <button
                                    type="button"
                                    class="nav-link"
                                    role="tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#navs-top-reviews"
                                    aria-controls="navs-top-reviews"
                                    aria-selected="false">
                                    Reviews
                                </button>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div class="tab-pane fade show active" id="navs-top-home" role="tabpanel">
                                <div className='table-responsive'>
                                    <table className='table table-sm'>
                                        <thead>
                                            <tr>
                                                <td>Date</td>
                                                <td>User Name</td>
                                                <td>Email</td>
                                                <td>Notes</td>
                                                <td>Action</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {OrderDetail.orderStatusLog && OrderDetail.orderStatusLog.map((data, key) => {
                                                return (<tr key={key}>
                                                    <td width="190px">{utc_local(data.createdAt, 'DD MMM YYYY HH:mm:ss')}</td>
                                                    <td style={{ 'minWidth': '180px' }}>{data.userName}</td>
                                                    <td style={{ 'minWidth': '220px' }}>{data.email}</td>
                                                    <td>{data.notes}</td>
                                                    <td>{data.action}</td>
                                                </tr>)
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                {(!OrderDetail.orderStatusLog || (OrderDetail.orderStatusLog && OrderDetail.orderStatusLog.length <= 0)) &&
                                    <p className='text-center'>No any data</p>
                                }
                            </div>
                            <div class="tab-pane fade" id="navs-top-reviews" role="tabpanel">
                                <div className='row'>
                                    {OrderDetail.productReview && OrderDetail.productReview.map((reviewInfo, index) => (
                                        <div className='col-sm-6 mb-3' key={index}>
                                            <div className='p-2 border rounded'>
                                                <div className='row mb-3 '>
                                                    <div className='col-sm-4'>
                                                        <img src={reviewInfo.Image1} alt={reviewInfo.designName} style={{ "maxWidth": "100px", "maxHeight": "100px" }} />
                                                    </div>
                                                    <div className='col-sm-8'>
                                                        <p className='mb-2'>{reviewInfo.designName}</p>
                                                        <p className='mb-2'>Order NO : {reviewInfo.orderId}</p>
                                                        <p className='mb-2'>Name : {reviewInfo.userName}</p>
                                                        <p className='mb-2'>{utc_local(reviewInfo.createdAt, 'DD MMM YYYY')}</p>
                                                    </div>
                                                </div>
                                                <div className='row mb-3'>
                                                    <div className='col-sm-12 mb-3'>
                                                        <StarRating rating={reviewInfo.rating} />
                                                    </div>
                                                    <div className='col-sm-12'>
                                                        <p>{reviewInfo.review}</p>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    {reviewInfo.images && reviewInfo.images.length > 0 && <>
                                                        {reviewInfo.images.map((image, key) => (
                                                            <div className='col-sm-4 text-center mb-2' key={key}>
                                                                <img src={image} alt="" style={{ "maxWidth": "100px", "maxHeight": "100px" }} />
                                                            </div>
                                                        ))}
                                                    </>}
                                                </div>

                                            </div>

                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="EditModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Update Order Status</h5>
                            <button type="button" className="btn btn-sm close modal-close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <hr className='mb-0' />
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <form className="av-invalid" onSubmit={handleSubmitOrderStatus}>
                                        <div className='mb-3'>
                                            <label className="form-label text-capitalize">Select Order Status </label>
                                            <select name='orderStatus' value={OrderFormInputs.orderStatus} onChange={handleInputChangeOrderStatus} className="form-control" >
                                                <option value="Pending">Pending</option>
                                                <option value="Order Placed">Order Placed</option>
                                                <option value="Order Confirmed">Order Confirmed</option>
                                                <option value="On Hold">On Hold</option>
                                                <option value="In Review">In Review</option>
                                                <option value="Packed">Packed</option>
                                                <option value="Shipped">Shipped</option>
                                                <option value="Out for Delivery">Out for Delivery</option>
                                                <option value="Delivered">Delivered</option>
                                                <option value="Cancelled">Cancelled</option>
                                                <option value="Returned">Returned</option>
                                                <option value="Refunded">Refunded</option>
                                            </select>
                                        </div>
                                        <div className='mb-3'>
                                            <label className="form-label text-capitalize"> Notes </label>
                                            <textarea name='orderNotes' value={OrderFormInputs.orderNotes} onChange={handleInputChangeOrderStatus} rows={4} className="form-control"></textarea>
                                        </div>
                                        <div className='text-center pt-4'>
                                            <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2"> {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Update </button>
                                            <button type='button' data-bs-dismiss="modal" aria-label="Close" className="btn btn-danger ms-3"> Cancel</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default OrdersDetail;